import { reloadNotificationAction } from "./types"

const initialState = {
    module_name: "",
    status: "",
    time: 2
}

export const reloadNotification = (state = initialState,{type, module_name, status, time}) => {
    switch(type){
        case reloadNotificationAction.START_RELOAD:
            return {
                ...state, 
                module_name: module_name,
                status: status,
                time: time,
            }
        case reloadNotificationAction.STOP_RELOAD:
            return {
                ...state, 
                module_name: "",
                status: "",
                time: 2,
            }      
        default: return state;
    }
}